import { Configuration2D } from '../../configuration2d';
import { Decoration } from './decoration';
import { Door } from './door';
import { FenceLocation } from './fence-location';
import { Resume } from '../../resume/resume';
import { Shape } from './shape';
import { Side } from './side';
import { PostType } from './post-type';
import { PanelCount } from './panel-count';
import { ConfigurationInstallation } from './configuration-installation';

export class Configuration extends Configuration2D {
  public location: FenceLocation;
  public shape: Shape;
  public sides: Side[] = [];

  public postType: PostType;
  public horizontalDecorativeBoards: Decoration[] = [];
  public horizontalDecorations: Decoration[] = [];
  public horizontalPanels: Decoration[] = [];
  public doors: Door[] = [];

  /**
   * Propriété utilisée que dans le front pour calculer le nombre de panneaux
   */
  public panelCount: PanelCount;
  public resume: Resume;
  public hasWall: boolean;
  public wallHeight: number;
  public isComplete?: boolean;
  public hasValidQuotation: boolean;
  public isShapeClosed?: boolean;
  public nbNonRightAngle?: number;
  public nbConcretePilarInAngle?: number;
  public confirmNoAngle?: boolean;
  public isVertical?: boolean;

  public configurationInstallations: ConfigurationInstallation[] = [];

  constructor() {
    super();
  }
}
